import React from 'react';
import { RateLockTab } from './RateLockTab';

// Products & Pricing is currently identical to the Rate Lock tab; keep as a
// thin alias so future divergence is a small change.
export function ProductsPricingModule({ loan, onChange }) {
  return <RateLockTab loan={loan} onChange={onChange} />;
}
